import { render, staticRenderFns } from "./KanbanFilters.vue?vue&type=template&id=35c7e132&"
import script from "./KanbanFilters.vue?vue&type=script&lang=js&"
export * from "./KanbanFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports